import keyMirror from 'keymirror';
import { withLanguageLocale } from '../../services/Helper';

export const subjectDetailsActionTypes = keyMirror({
	GET_SUBJECT_DETAILS: null,
	GET_SUBJECT_DETAILS_SUCCESS: null,
	GET_SUBJECT_DETAILS_ERROR: null,
	GET_SUBJECT_TOPICS: null,
	GET_SUBJECT_TOPICS_SUCCESS: null,
	GET_SUBJECT_TOPICS_ERROR: null,
	GET_SUBJECT_EXAMS: null,
	GET_SUBJECT_EXAMS_SUCCESS: null,
	GET_SUBJECT_EXAMS_ERROR: null,
	SET_SUBJECT_DETAILS_LISTS_LOADING: null,
	CHANGE_SUBJECT_TOPICS_FILTERS: null,
	CLEAN_SUBJECT_DETAILS_STATE: null,
});

export const getSubjectDetailsTabs = (subject, t, showTopics, showExams, isPublic) => {
	const filteredList = getSubjectTabs(t).filter((item) => {
		if (isPublic && (!item.value || item.value === 'created' || item.value === 'groups'))
			return false;
		if (item.value === 'topics') return showTopics;
		if (item.value === 'exams') return showExams;
		return true;
	});

	return filteredList.map((item, index) => ({
		...item,
		link: withLanguageLocale(`/subjects/${subject}${item.value ? `/${item.value}` : ''}`),
		index: isPublic ? index : item.index,
	}));
};

export const getSubjectTabs = (t) => [
	{ title: t('subject_details.tabs.recent'), value: '', index: 0 },
	{ title: t('subject_details.tabs.topics'), value: 'topics', index: 1 },
	{ title: t('subject_details.tabs.exams'), value: 'exams', index: 2 },
	{ title: t('subject_details.tabs.created'), value: 'created', index: 3 },
	{ title: t('subject_details.tabs.groups'), value: 'groups', index: 4 },
];
